import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { FaShareAltSquare, FaYoutube } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

import toast from "react-hot-toast";
import AnimatedBackground from "../components/quizBackgrounds/bimer/BimerAnimatedBackground";

import bimer from "../assets/logos/bimer.png";

const CongratsPage = () => {
	const { quizId } = useParams();

	const [width, setWidth] = useState(window.innerWidth);

	useEffect(() => {
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const handleResize = () => {
		setWidth(window.innerWidth);
	};

	const handleShareQuiz = () => {
		const host = window.location.origin;
		navigator.clipboard.writeText(host + "/start/" + quizId);
		toast.success("Le lien du quiz a été copié dans le presse-papier !");
	};

	return (
		<div className="relative h-full w-full flex justify-center items-center">
			<AnimatedBackground />
			<div className="absolute  p-4 z-20">
				<img
					className="mb-5 justify-self-center"
					src={bimer}
					width={width > 700 ? width / 4 : width / 2}
					alt="Bimer"
				/>
				<div className="bg-white bg-opacity-85 p-4 rounded-lg shadow-md text-sm">
					<h1 className="text-3xl font-bold mb-4">Merci !</h1>
					{/* <CongratsSVG className="w-48 h-48 mb-6" /> */}
					<p className="mb-6 text-md">Vous avez terminé le quiz avec succès.</p>

					<p className="mb-6 text-md">
						Avant de fermer cette page, venez faire un petit tour sur nos
						reseaux sociaux!
					</p>

					<div
						className={`mb-8 ${
							width > 700 ? "flex gap-4" : "flex flex-col gap-4 items-center"
						} `}
					>
						<button
							className="bg-red-500 max-w-[150px] text-white px-4 py-2 rounded-full flex items-center gap-2 hover:bg-red-600"
							onClick={() =>
								window.open(
									"https://www.youtube.com/@bimerservices1020",
									"_blank"
								)
							}
						>
							<FaYoutube height={48} className="text-white" />
							YouTube
						</button>
						<button
							className="bg-blue-700 max-w-[150px] text-white px-4 py-2 rounded-full flex items-center gap-2 hover:bg-blue-800"
							onClick={() =>
								window.open(
									"https://www.linkedin.com/company/bimer-services/posts/?feedView=all",
									"_blank"
								)
							}
						>
							<FaLinkedinIn height={48} className="text-white" />
							LinkedIn
						</button>
						<button
							className="flex bg-black  max-w-[150px] text-white px-4 py-2 rounded-full items-center gap-2 hover:bg-gray-800"
							onClick={handleShareQuiz}
						>
							<FaShareAltSquare height={48} />
							Copier le lien
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CongratsPage;
